export default __webpack_public_path__ + "static/media/eskil-min.9b5ad9e1.png";